import {Component, Input} from "@angular/core";
import {AuthService} from "../../../../../services/auth.service";
import {RootShareService} from "../../../../../services/root.shared.service";
import {OcularMotilityAndMuscleBalance} from "../../../../../models/forms/referral/ocular.motility.and.muscle.balance";

@Component({
    selector: 'ocular-motility-and-muscle-balance-component',
    templateUrl: './ocular.motility.and.muscle.balance.html'
})
export class OcularMotilityAndMuscleBalanceComponent {
    @Input() ocularMotilityAndMuscleBalance: OcularMotilityAndMuscleBalance;

    @Input() patient: any;
    @Input() patientDocument: any;
    @Input() readOnly: Boolean = false;

    constructor(private _rootShareService: RootShareService, private _auth: AuthService) {
    }
}
